var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReturn = function SvgReturn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m27.375 26.916.897.897-3.992 3.993 3.992 3.992-.897.897-4.89-4.89zM18.923 14.354l.611-2.994.306-1.496.153-.749 1.306.267-.153.748-.306 1.497-.612 2.994zM25.464 9.381l.153.748.306 1.497.611 2.994 1.306-.267-.612-2.994-.306-1.496-.153-.749zM20.241 22.953V15.12h-1.332v9.93l4.472-2.1 4.473 2.1v-9.93h-1.332v7.833l-3.141-1.476z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.878 8.83h22.559l5.974 5.434v25.714H6.35V14.28zm.612 1.333L8.465 13.86h29.752l-4.361-3.697zm26.588 5.029H7.682v23.454h31.396z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.382 32.489h17.486a4.783 4.783 0 0 0 0-9.566h-1.625v1.269h1.625a3.514 3.514 0 0 1 0 7.028H23.382z",
    clipRule: "evenodd"
  })));
};
export { SvgReturn as ReactComponent };
export default "/_next/static/images/return.svg";